import type { CatalogItem } from '../../models/CatalogItem';
import { AuditActionType } from '../../models/enums';
import { delay, readCollection, seedCollection } from './dataverseClient';
import { auditLogService } from './auditLogService';
import { catalogSeed } from './mockData';
import { apiClient } from '../api/apiClient';

const ENTITY = 'cr_crm_catalogcache';

class CatalogService {
  private ensureSeed(): void {
    seedCollection(ENTITY, catalogSeed);
  }

  async list(): Promise<CatalogItem[]> {
    if (apiClient.isConfigured()) {
      try {
        const res = await apiClient.get<{ totalCount: number; items: CatalogItem[] }>('/api/catalog?country=TN') as unknown;
        const apiItems: CatalogItem[] = Array.isArray(res) ? res as CatalogItem[] : ((res as { items?: CatalogItem[] }).items ?? []);
        if (apiItems.length > 0) return apiItems;
      } catch { /* fall through to seed */ }
    }
    this.ensureSeed();
    await delay();
    return readCollection<CatalogItem>(ENTITY).sort((a, b) => a.cr_crm_productname.localeCompare(b.cr_crm_productname));
  }

  async getBySku(sku: string): Promise<CatalogItem | null> {
    this.ensureSeed();
    await delay();
    return readCollection<CatalogItem>(ENTITY).find((item) => item.cr_crm_skuid === sku) ?? null;
  }

  async refresh(): Promise<CatalogItem[]> {
    if (apiClient.isConfigured()) {
      const res = await apiClient.get<{ totalCount: number; items: CatalogItem[] }>('/api/catalog?country=TN') as unknown;
      const items: CatalogItem[] = Array.isArray(res) ? res as CatalogItem[] : ((res as { items?: CatalogItem[] }).items ?? []);
      await auditLogService.record({ actionType: AuditActionType.Sync, entityName: 'Catalog', description: 'Catalog cache refreshed from Partner Center.' });
      return items;
    }
    this.ensureSeed();
    await delay(200);
    const items = readCollection<CatalogItem>(ENTITY).map((item) => ({ ...item, modifiedon: new Date().toISOString() }));
    localStorage.setItem('crm-app:cr_crm_catalogcache', JSON.stringify(items));
    await auditLogService.record({ actionType: AuditActionType.Sync, entityName: 'Catalog', description: 'Catalog cache refreshed.' });
    return items;
  }
}

export const catalogService = new CatalogService();

